import React from 'react';
import Sessions from './sessions';

export function ArchivedSessions() {
  return <Sessions archivedView />
}

export default ArchivedSessions;
